module.exports = __webpack_public_path__ + "static/media/cyber-security-purplish-blue.eab4415b.gif";